<app-maintenance-window />
<app-menu [menu]="menu" [whitebackground]="true">
  <router-outlet slot="content"></router-outlet>
</app-menu>
